<template>
    <div class="card" :class="{hoverable: hoverable !== undefined}">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'card',

  props: ['hoverable'],
};
</script>

<style scoped>
.card.hoverable {
  cursor: pointer;
}

.card.hoverable {
  top: 0;
  transition: top 150ms ease;
}

.card.hoverable:hover {
  top: -0.25em;
}
</style>


// WEBPACK FOOTER //
// src/components/Card.vue